import type { Tip } from '@/cms/fields/mappers/destinationPageFieldsMapper'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { Carousel } from '@/scopes/common/components/Carousel'
import cn from 'classnames'
import { isEmpty } from 'ramda'
import SectionTitle from '../SectionTitle'
import { TipCard } from './TipCard/TipCard'
import styles from './Tips.module.css'

function renderTipCard(tip: Tip) {
  return (
    <TipCard
      title={tip.authorName}
      description={tip.description}
      mediaSrc={tip.image}
      avatar={tip.authorPicture}
      subtitle={tip.subtitle}
    />
  )
}

export function Tips() {
  const intl = useIntl()
  const tips = useCMSPageField('DestinationPage.tips')

  if (isEmpty(tips)) {
    return null
  }

  const showGrid = tips.length === 2

  return (
    <div className={styles.tipsWrapper}>
      <section>
        <SectionTitle>{intl.formatMessage({ id: 'destination_tips_title' })}</SectionTitle>
        {showGrid && (
          <div className={styles.tipsGrid}>
            {tips.map(tip => (
              <div key={tip.authorName}>{renderTipCard(tip)}</div>
            ))}
          </div>
        )}
        {tips.length === 1
          ? (
              <div className={styles.tipSlide}>{renderTipCard(tips[0])}</div>
            )
          : (
              <Carousel
                showNavigation={false}
                showDots
                controlsPosition="outside"
                slideSpacing="var(--primitives-space-16)"
                className={cn(styles.carousel, { [styles.carouselOnly]: !showGrid })}
              >
                {tips.map(tip => (
                  <div className={styles.tipSlide} key={tip.authorName}>
                    {renderTipCard(tip)}
                  </div>
                ))}
              </Carousel>
            )}
      </section>
    </div>
  )
}
